import type { EngageTenantUsage } from '@reach/shared-types/engage-tenants';
import { serializeCsvRow, type CsvCell } from '../../../lib/csv-utils';

const ENGAGE_TENANT_CSV_HEADERS: CsvCell[] = [
  'tenant_name',
  'tenant_external_id',
  'emails_sent',
  'sms_sent',
  'total_sends',
  'active_automations',
  'sms_numbers',
];

export function buildEngageTenantCsvLines(tenants: EngageTenantUsage[]): string[] {
  return [
    serializeCsvRow(ENGAGE_TENANT_CSV_HEADERS),
    ...tenants.map(tenant =>
      serializeCsvRow([
        tenant.tenantName,
        tenant.tenantExternalId ?? '',
        tenant.emailsSent,
        tenant.smsSent,
        tenant.totalSends,
        tenant.activeAutomations,
        tenant.smsNumberCount,
      ]),
    ),
  ];
}

export function getEngageTenantsCsvFilename(selectedDays: number): string {
  const today = new Date().toISOString().slice(0, 10);
  const filePeriod = selectedDays === 0 ? 'all-time' : `last-${selectedDays}d`;
  return `engage_tenant_usage_${filePeriod}_${today}.csv`;
}
